import { useEffect } from 'react';
import { useQuoteModal } from '../../context/QuoteModalContext';
import QuoteForm from './QuoteForm';

export default function QuoteModal() {
  const { isOpen, closeModal } = useQuoteModal();

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => { document.body.style.overflow = ''; };
  }, [isOpen]);

  useEffect(() => {
    const handleKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') closeModal();
    };
    window.addEventListener('keydown', handleKey);
    return () => window.removeEventListener('keydown', handleKey);
  }, [closeModal]);

  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 z-[999] flex items-center justify-center p-4"
      onClick={closeModal}
    >
      {/* Overlay */}
      <div className="absolute inset-0 bg-black/70 backdrop-blur-sm"></div>

      {/* Modal */}
      <div
        className="relative z-10 bg-gray-900 rounded-2xl w-full max-w-2xl max-h-[92vh] overflow-y-auto"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Teal accent top bar */}
        <div className="h-1 w-full bg-gradient-to-r from-teal-400 to-teal-600 rounded-t-2xl"></div>

        {/* Header */}
        <div className="px-8 pt-7 pb-4 flex items-start justify-between gap-4">
          <div>
            <h2 className="text-2xl font-extrabold text-white mb-1">Inquire Now</h2>
            <p className="text-gray-400 text-sm">
              Tell us what you need — to rent for an event or to buy outright — and we&apos;ll reply within 24 hours
            </p>
          </div>
          <button
            onClick={closeModal}
            className="w-9 h-9 flex-shrink-0 flex items-center justify-center bg-white/10 hover:bg-white/20 text-white rounded-full transition-colors cursor-pointer mt-0.5"
          >
            <i className="ri-close-line text-lg"></i>
          </button>
        </div>

        <div className="px-8 pb-8">
          <QuoteForm theme="dark" onClose={closeModal} />
        </div>
      </div>
    </div>
  );
}
